/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import { getOpponentsByLeage } from "../../../../features/cms/cmsSlice";
import FormTitle from "../../../FormTitle/FormTitle";
import styles from "./ByOpponent.module.scss";
import LeagueBox from "./LeagueBox";

const ByOpponent = () => {
  const history = useHistory();
  const { type } = useSelector((state) => state.singleGroup);
  const leagues = useSelector(getOpponentsByLeage);

  useEffect(() => {
    if (!type) history.push("/");
  }, [leagues, history, type]);

  return (
    <div className={styles.body}>
      <FormTitle title="Select Opponent" />
      <div className={styles.wrapper}>
        {/* {leagues &&
          Object.keys(leagues)?.map((key, i) => (
            <LeagueBox league={key} teams={leagues[key]} key={i * 1000} />
            ))} */}
        <LeagueBox
          league="National League East"
          teams={leagues["National League East"]}
        />
        <LeagueBox
          league="National League Central"
          teams={leagues["National League Central"]}
        />
        <LeagueBox
          league="National League West"
          teams={leagues["National League West"]}
        />
        <LeagueBox
          league="American League East"
          teams={leagues["American League East"]}
        />
        <LeagueBox
          league="American League Central"
          teams={leagues["American League Central"]}
        />
        <LeagueBox
          league="American League West"
          teams={leagues["American League West"]}
        />
      </div>
      <FormController
        backTo="/ticket-single-group"
        startOver="/"
        showBack
        showStartOver
      />
    </div>
  );
};

export default ByOpponent;
